import questionsMixin from "@/mixins/questions.mixin"
import parsedQuestionListMixin from '@/mixins/parsed-question-list.mixin'

export default {
    mixins: [questionsMixin,parsedQuestionListMixin],

    data() {
        return {
            logicalOperators: ["and", "or", "not", "x-or"],
            conditionals: ["if", "always", "else"],
            currentDisplayLogic: {}
        }
    },

    props: {
        displayLogic: {
            type: Object,
            default: () => {}
        },

        formFields: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        showAddQuestion() {
            return ['','always'].includes(this.currentDisplayLogic.conditional) === false && this.currentDisplayLogic.operator
        },

        showCurrentOperator() {
            return (index) => this.currentDisplayLogic.operator && index !== this.currentDisplayLogic.questions.length - 1
        }
    },

    watch: {
        displayLogic: {
            handler: function(newVal) {
                if(newVal) {
                    this.currentDisplayLogic = {...newVal}
                } else {
                    this.currentDisplayLogic = {
                        operator: null,
                        conditional: null,
                        questions: []
                    }
                }
            },
            deep: true
        }
    },

    mounted() {
        this.currentDisplayLogic = {...this.displayLogic}
    }, 

    methods: {
        deleteQuestion(index) {
            this.currentDisplayLogic.questions.splice(index, 1);
            this.$emit('update', {...this.currentDisplayLogic})
        },
    
        addQuestion() {
            if(!this.currentDisplayLogic?.questions)
                this.currentDisplayLogic.questions = []
                
            this.currentDisplayLogic.questions.push({
                uid: null,
                title: null,
                type: null,
                selection: {},
                options: [],
            });
            this.$emit('update', {...this.currentDisplayLogic})
        },


        getSelectedQuestionAnswers(uid, index) {
            for (let i = 0; i < this.parsedQuestionList.length; i++) {
                if (this.parsedQuestionList[i].uid === uid) {
                    const currentQuestion = this.parsedQuestionList[i];

                    const currentAnswerOptions = this.getSelectedQuestionAnswer(currentQuestion);

                    this.currentDisplayLogic.questions[index].title = currentQuestion.title;
                    this.currentDisplayLogic.questions[index].uid = currentQuestion.uid;
                    this.currentDisplayLogic.questions[index].type = currentQuestion.type;
                    this.currentDisplayLogic.questions[index].options = currentAnswerOptions;
                    this.$forceUpdate();
                }
            }
        },
    }
}